import React from 'react';
import Chart from 'react-apexcharts';

const StatusChart2 = ({ Data }) => {
    const series = Data.map(status => status.cnt);
    const labels = Data.map(status => status.job_opening_status);

    const chartState = {
        series,
        options: {
            chart: {
                type: 'donut',
                height: 300,
            },
            labels,
            dataLabels: {
                enabled: false,
            },
            responsive: [
                {
                    breakpoint: 767,
                    options: {
                        chart: {
                            height: 300,
                        },
                    },
                },
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            height: 400,
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
        },
    };

    return (
        
        <Chart options={chartState.options} series={chartState.series} type="donut" height={300} />
    );
};

export default StatusChart2;
